import commonApi from './CommonApi.js';

export default {
    getParties: async (parameters) => {
        return await commonApi().get('/statistics/get-parties', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getByPartyId: async (parameters) => {
        return await commonApi().get('/statistics/by-party-id', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getAggregatedAnnexes: async (parameters) => {
        return await commonApi().get('/statistics/get-aggregated-annexes', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getAggregatedCategories: async (parameters) => {
        return await commonApi().get('/statistics/get-aggregated-categories', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getStatisticsSummary: async (parameters) => {
        return await commonApi().get('/statistics/get-statistics-summary', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    }
}
